export default "__VITE_ASSET__BK3oYO8a__"